import { State } from "@app/root-store/app.state";
import { createSelector } from "@ngrx/store";
import { initialMunicipalityState, MunicipalityState } from "../reducers";

const selectFeature = (state: State) => state.municipality;

const selectActiveMunicipality = (state: MunicipalityState) =>
    state?.activeProjectMunicipality || initialMunicipalityState.activeProjectMunicipality;

export const getActiveMunicipality = createSelector(selectFeature, state => selectActiveMunicipality(state));
